/**
 * Generato automaticamente.
 * framework-cmp-domande
 */

export type EnumDestinatarioStatoComunicazione =
  (typeof EnumDestinatarioStatoComunicazione)[keyof typeof EnumDestinatarioStatoComunicazione];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EnumDestinatarioStatoComunicazione = {
  IN_LAVORAZIONE: 'IN_LAVORAZIONE',
  SUCCESSO: 'SUCCESSO',
  FALLIMENTO: 'FALLIMENTO',
} as const;
